
import { supabase } from "@/integrations/supabase/client";
import { AIConfig } from "@/types/admin";

export const MOCK_AI_CONFIG_ID = "00000000-0000-0000-0000-000000000001";

export const fetchAIConfigs = async (): Promise<AIConfig[]> => {
  try {
    const { data, error } = await supabase
      .from('ai_configs')
      .select('*');
    
    if (error) throw error;
    return data as AIConfig[];
  } catch (error) {
    console.error("Error fetching AI configs:", error);
    return [];
  }
};

export const fetchAIConfigByTask = async (forTask: 'pre-call' | 'post-call'): Promise<AIConfig | null> => {
  try {
    const { data, error } = await supabase
      .from('ai_configs')
      .select('*')
      .eq('for_task', forTask)
      .order('updated_at', { ascending: false })
      .limit(1)
      .single();
    
    if (error) throw error;
    return data as AIConfig;
  } catch (error) {
    console.error(`Error fetching AI config for task ${forTask}:`, error);
    return null;
  }
};

export const updateAIConfig = async (config: AIConfig): Promise<{ success: boolean; error?: string }> => {
  try {
    const { id, ...configData } = config;
    const updatedData = {
      ...configData,
      updated_at: new Date().toISOString(),
    };
    
    let response;
    if (id) {
      response = await supabase
        .from('ai_configs')
        .update(updatedData)
        .eq('id', id);
    } else {
      response = await supabase
        .from('ai_configs')
        .insert([updatedData]);
    }
    
    if (response.error) throw response.error;
    
    return { success: true };
  } catch (error) {
    console.error("Error updating AI config:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "Unknown error" 
    };
  }
};
